<template>
  <div class="cp-root">
    <!-- ── HEADER ── -->
    <div class="cp-header">
      <div class="cp-header-left">
        <button class="cp-back-btn" @click="$emit('voltar')">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div class="cp-header-icon">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        <div>
          <h1 class="cp-title">
            {{ dadosClienteSelecionado.nome || "Perfil de Cliente" }}
          </h1>
          <p class="cp-sub">QR {{ dadosClienteSelecionado.qr_code }}</p>
        </div>
      </div>
      <div class="cp-header-right">
        <button
          class="cp-action-btn"
          @click="enviarMensagemindividual(dadosClienteSelecionado)"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
          >
            <line x1="22" y1="2" x2="11" y2="13" />
            <polygon points="22 2 15 22 11 13 2 9 22 2" />
          </svg>
          Enviar Mensagem
        </button>
        <button
          class="cp-action-btn"
          @click="verHistoricoCampanhas(dadosClienteSelecionado)"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
          >
            <path
              d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            />
          </svg>
          Histórico de Mensagens
        </button>
      </div>
    </div>

    <!-- ── FILTROS ── -->
    <perfil-filtros
      :opcoes="restaurantes"
      :restaurantes.sync="restaurantesSelecionados"
      :start.sync="dates.start"
      :end.sync="dates.end"
      @filtrar="processarCliente"
    />

    <!-- ── INFO + STATS ── -->
    <perfil-info
      :cliente="dadosClienteSelecionado"
      @editar-nif="ativarEdicaoNif"
    />

    <!-- ── ESTATÍSTICAS ── -->
    <perfil-estatisticas :cliente="dadosClienteSelecionado" />

    <!-- ── CONSUMOS + REFEIÇÕES ── -->
    <perfil-consumos
      :categoria-atual="categoriaAtual"
      :categoria-formatada="categoriaFormatada"
      :itens="visibleItemsCategoria"
      :pode-prev-categoria="canGoPrevCategoria"
      :pode-next-categoria="canGoNextCategoria"
      :visitas="visitasPaginadas"
      :total-visitas="visitasFiltradas.length"
      :page-size="pageSizeVisitas"
      :pode-prev-visitas="canGoPrevVisitas"
      :pode-next-visitas="canGoNextVisitas"
      @categoria-anterior="mudarCategoriaAnterior"
      @categoria-seguinte="mudarCategoriaSeguinte"
      @prev-categoria="goToPrevPageCategoria"
      @next-categoria="goToNextPageCategoria"
      @prev-visitas="goToPrevPageVisitas"
      @next-visitas="goToNextPageVisitas"
      @abrir-visita="abrirModalVisita"
    />

    <!-- ── GRÁFICOS ── -->
    <perfil-graficos
      :restaurantes="pieRestaurantesLocal"
      :refeicoes="pieRefeicoesLocal"
    />

    <!-- ── MODAL: Histórico de Campanhas ── -->
    <b-modal
      v-model="modalCampanhas"
      title="Histórico de Envio"
      size="lg"
      hide-footer
      dialog-class="modal-altura-fixa"
    >
      <template v-if="campanhaSelecionadas.length > 0">
        <div class="cp-modal-scroll">
          <div
            v-for="(item, index) in campanhaSelecionadas"
            :key="index"
            class="cp-campanha-item"
          >
            <div class="cp-campanha-meta">
              <span class="cp-campanha-titulo">{{ item.titulo_campanha }}</span>
              <span class="cp-campanha-canal">{{ item.canal }}</span>
            </div>
            <p class="cp-campanha-msg">
              {{
                item.mensagem.length > 150
                  ? item.mensagem.slice(0, 150) + "…"
                  : item.mensagem
              }}
            </p>
            <span class="cp-campanha-data"
              >{{ formatarData(item.data_envio) }} · {{ item.hora_envio }}</span
            >
          </div>
        </div>
      </template>
      <div v-else class="cp-modal-empty">
        Sem campanhas enviadas para este cliente.
      </div>
    </b-modal>

    <!-- ── MODAL: Detalhes da Visita ── -->
    <b-modal
      v-model="modalVisita"
      title="Detalhes da Visita"
      size="lg"
      hide-footer
      dialog-class="modal-altura-fixa"
    >
      <template v-if="visitaSelecionada">
        <div class="cp-modal-scroll">
          <div class="cp-visita-meta">
            <div class="cp-visita-meta-item">
              <span>Data</span
              ><strong>{{
                formatarData(visitaSelecionada.data_visita)
              }}</strong>
            </div>
            <div class="cp-visita-meta-item">
              <span>Refeição</span
              ><strong>{{ visitaSelecionada.refeicao }}</strong>
            </div>
            <div class="cp-visita-meta-item">
              <span>Restaurante</span
              ><strong>{{ visitaSelecionada.restaurante || "–" }}</strong>
            </div>
            <div class="cp-visita-meta-item">
              <span>Total</span
              ><strong class="cp-visita-total">{{
                formatarEuro(visitaSelecionada.total_pago || 0)
              }}</strong>
            </div>
          </div>
          <div class="cp-consumos-list">
            <div
              v-for="(item, index) in visitaSelecionada.consumos"
              :key="index"
              class="cp-consumo-row"
            >
              <div>
                <span class="cp-consumo-nome">{{ item.produto }}</span>
                <span class="cp-consumo-cat">{{ item.categoria }}</span>
              </div>
              <span class="cp-consumo-qty">{{ item.quantidade }} un.</span>
              <span class="cp-consumo-val">{{
                formatarEuro(item.pago || 0)
              }}</span>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { cartaoService } from "@/services";
  import Chart from "chart.js";
  import ChartDataLabels from "chartjs-plugin-datalabels";
  import { Portuguese } from "flatpickr/dist/l10n/pt.js";
  import PerfilFiltros from "./Perfil/PerfilFiltros.vue";
  import PerfilInfo from "./Perfil/PerfilInfo.vue";
  import PerfilEstatisticas from "./Perfil/PerfilEstatisticas.vue";
  import PerfilConsumos from "./Perfil/PerfilConsumos.vue";
  import PerfilGraficos from "./Perfil/PerfilGraficos.vue";

  Chart.plugins.register(ChartDataLabels);

  const PALETTE = ["#FF5D2C", "#FF825D", "#FFA570", "#FF931F", "#FFAD33"];
  const FALLBACK_COLOR = "#FEBE5F";
  const PIE_OPTIONS = {
    responsive: true,
    legend: {
      display: true,
      position: "bottom",
      labels: {
        usePointStyle: true,
        padding: 20,
        fontColor: "#333",
        fontSize: 12,
      },
    },
    tooltips: {
      callbacks: {
        label(ti, data) {
          const ds = data.datasets[ti.datasetIndex];
          const label = data.labels[ti.index] || "";
          const gasto = ds.data[ti.index].toFixed(2);
          const visitas = ds.meta?.visitas?.[ti.index] ?? "";
          return `${label}: ${gasto}€ | ${visitas} visitas`;
        },
      },
    },
    animation: { animateScale: true, animateRotate: true },
    plugins: {
      datalabels: {
        color: "#fff",
        font: { weight: "bold" },
        formatter(value, ctx) {
          if (!value) return "";
          const ds = ctx.chart?.data?.datasets?.[0];
          if (!ds?.data) return "";
          const total = ds.data.reduce((a, b) => a + b, 0);
          const perc = total ? ((value / total) * 100).toFixed(1) : 0;
          return perc > 0 ? perc + "%" : "";
        },
      },
    },
  };

  function buildPie(array, label) {
    const top5 = array.slice(0, 5);
    const outros = array.slice(5);
    if (outros.length)
      top5.push({
        label: "Outros",
        gasto: outros.reduce((s, i) => s + i.gasto, 0),
        visitas: outros.reduce((s, i) => s + i.visitas, 0),
      });
    return {
      chartData: {
        labels: top5.map((i) => i.label),
        datasets: [
          {
            data: top5.map((i) => i.gasto),
            backgroundColor: top5.map((_, idx) =>
              idx < PALETTE.length ? PALETTE[idx] : FALLBACK_COLOR,
            ),
            label,
            meta: { visitas: top5.map((i) => i.visitas) },
          },
        ],
      },
      extraOptions: { ...PIE_OPTIONS },
    };
  }

  export default {
    name: "ClientePerfil",
    components: {
      PerfilFiltros,
      PerfilInfo,
      PerfilEstatisticas,
      PerfilConsumos,
      PerfilGraficos,
    },
    props: {
      dadosClienteSelecionado: { type: Object, required: true },
      restaurantes: { type: Array, default: () => [] },
    },
    data() {
      return {
        restaurantesSelecionados: [],
        dates: { start: null, end: null },
        pieRestaurantesLocal: {
          chartData: { labels: [], datasets: [] },
          extraOptions: {},
        },
        pieRefeicoesLocal: {
          chartData: { labels: [], datasets: [] },
          extraOptions: {},
        },
        listAllConsumosLocal: {},
        categoriasUnicas: [],
        categoriaAtual: null,
        itemsPerPage: 5,
        currentPageCategoria: 1,
        currentPageVisitas: 1,
        pageSizeVisitas: 5,
        modalCampanhas: false,
        modalVisita: false,
        campanhaSelecionadas: [],
        visitaSelecionada: null,
        editarNif: false,
        nifTemp: null,
      };
    },
    computed: {
      categoriaFormatada() {
        const s = this.categoriaAtual;
        return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "";
      },
      visibleItemsCategoria() {
        const start = (this.currentPageCategoria - 1) * this.itemsPerPage;
        return (
          this.listAllConsumosLocal[this.categoriaAtual]?.slice(
            start,
            start + this.itemsPerPage,
          ) || []
        );
      },
      canGoNextCategoria() {
        const total =
          this.listAllConsumosLocal[this.categoriaAtual]?.length || 0;
        return this.currentPageCategoria < Math.ceil(total / this.itemsPerPage);
      },
      canGoPrevCategoria() {
        return this.currentPageCategoria > 1;
      },
      visitasFiltradas() {
        if (!this.dadosClienteSelecionado.visitas) return [];
        const start = this.dates?.start ? new Date(this.dates.start) : null;
        const end = this.dates?.end ? new Date(this.dates.end) : null;
        const rSel = this.restaurantesSelecionados || [];
        return this.dadosClienteSelecionado.visitas.filter((v) => {
          const d = v.data_visita ? new Date(v.data_visita) : null;
          const okDatas = !d || ((!start || d >= start) && (!end || d <= end));
          const okRest = !rSel.length || rSel.includes(v.restaurante);
          return okDatas && okRest;
        });
      },
      visitasPaginadas() {
        const start = (this.currentPageVisitas - 1) * this.pageSizeVisitas;
        return this.visitasFiltradas.slice(start, start + this.pageSizeVisitas);
      },
      canGoPrevVisitas() {
        return this.currentPageVisitas > 1;
      },
      canGoNextVisitas() {
        return (
          this.currentPageVisitas * this.pageSizeVisitas <
          this.visitasFiltradas.length
        );
      },
    },
    watch: {
      dadosClienteSelecionado: {
        immediate: true,
        handler() {
          if (this.dadosClienteSelecionado) this.processarCliente();
        },
      },
      dates: {
        deep: true,
        handler() {
          this.processarCliente();
        },
      },
      restaurantesSelecionados() {
        this.processarCliente();
      },
    },
    methods: {
      // ── NIF ──────────────────────────────────────────────────────────
      ativarEdicaoNif() {
        this.nifTemp = this.dadosClienteSelecionado.nif;
        this.editarNif = true;
      },
      validarNIF(nif) {
        if (!nif) return false;
        nif = String(nif).trim();
        if (!/^\d{9}$/.test(nif)) return false;
        const d = nif.split("").map(Number);
        let check = 0;
        for (let i = 0; i < 8; i++) check += d[i] * (10 - i - 1);
        check = 11 - (check % 11);
        if (check >= 10) check = 0;
        return check === d[8];
      },
      async atualizarNifBackend(cliente) {
        try {
          await cartaoService.updateNif(cliente.qr_code, cliente.nif);
          this.$notify({
            message: "<b>NIF atualizado com sucesso.</b>",
            timeout: 2500,
            icon: "ni ni-bell-55",
            type: "success",
          });
        } catch {
          this.$notify({
            message: "<b>Erro ao atualizar o NIF.</b>",
            timeout: 3000,
            icon: "ni ni-bell-55",
            type: "warning",
          });
        }
      },

      // ── Processar cliente (filtros locais) ────────────────────────────
      processarCliente() {
        const array = this.dadosClienteSelecionado;
        this.currentPageCategoria = 1;

        const start = this.dates?.start ? new Date(this.dates.start) : null;
        const end = this.dates?.end ? new Date(this.dates.end) : null;
        const rSel = this.restaurantesSelecionados || [];

        const visitas = (array.visitas || []).filter((v) => {
          const d = v.data_visita ? new Date(v.data_visita) : null;
          const okDatas = !d || ((!start || d >= start) && (!end || d <= end));
          const okRest =
            !rSel.length ||
            rSel.some(
              (r) =>
                r?.toString().trim().toLowerCase() ===
                v.restaurante?.toString().trim().toLowerCase(),
            );
          return okDatas && okRest;
        });

        const consumos = [
          ...(array.consumos_comida || []),
          ...(array.consumos_bebidas || []),
        ].filter((c) => {
          const d = c.data ? new Date(c.data) : null;
          const okDatas = !d || ((!start || d >= start) && (!end || d <= end));
          const okRest =
            !rSel.length ||
            !c.restaurante ||
            rSel.some(
              (r) =>
                r?.toString().trim().toLowerCase() ===
                c.restaurante?.toString().trim().toLowerCase(),
            );
          return okDatas && okRest;
        });

        // agrupar por categoria
        const agrupado = {};
        for (const c of consumos) {
          const cat = c.categoria || "Outros";
          if (!agrupado[cat]) agrupado[cat] = {};
          if (!agrupado[cat][c.produto])
            agrupado[cat][c.produto] = {
              name: c.produto,
              quantidade: 0,
              total_pago: 0,
            };
          agrupado[cat][c.produto].quantidade += c.total_quantidade;
          agrupado[cat][c.produto].total_pago += c.total_pago ?? 0;
        }

        this.listAllConsumosLocal = {};
        this.categoriasUnicas = [];
        for (const cat in agrupado) {
          const lista = Object.values(agrupado[cat]);
          const totalUn = lista.reduce((s, i) => s + i.quantidade, 0);
          this.$set(
            this.listAllConsumosLocal,
            cat,
            lista
              .sort((a, b) => b.quantidade - a.quantidade)
              .map((i) => ({
                name: i.name,
                color: "orange",
                progress: totalUn
                  ? Math.round((i.quantidade / totalUn) * 100)
                  : 0,
                unidades_vendidas: i.quantidade,
                total_pago: i.total_pago,
              })),
          );
          this.categoriasUnicas.push(cat);
        }
        if (this.categoriasUnicas.length) {
          if (
            !this.categoriaAtual ||
            !this.categoriasUnicas.includes(this.categoriaAtual)
          )
            this.categoriaAtual = this.categoriasUnicas[0];
        } else {
          this.categoriaAtual = null;
        }

        // gráficos
        const restMap = {},
          refMap = {};
        for (const v of visitas) {
          if (v.restaurante) {
            restMap[v.restaurante] = restMap[v.restaurante] || {
              label: v.restaurante,
              gasto: 0,
              visitas: 0,
            };
            restMap[v.restaurante].gasto += v.total_pago ?? 0;
            restMap[v.restaurante].visitas++;
          }
          if (v.refeicao) {
            refMap[v.refeicao] = refMap[v.refeicao] || {
              label: v.refeicao,
              gasto: 0,
              visitas: 0,
            };
            refMap[v.refeicao].gasto += v.total_pago ?? 0;
            refMap[v.refeicao].visitas++;
          }
        }
        this.pieRestaurantesLocal = buildPie(
          Object.values(restMap).sort((a, b) => b.gasto - a.gasto),
          "Gasto por Restaurante (€)",
        );
        this.pieRefeicoesLocal = buildPie(
          Object.values(refMap).sort((a, b) => b.gasto - a.gasto),
          "Gasto por Refeição (€)",
        );

        this.dadosClienteSelecionado.visitas_total = visitas.length;
        this.dadosClienteSelecionado.gasto_total = visitas.reduce(
          (s, v) => s + (v.total_pago ?? 0),
          0,
        );
      },

      // ── Navegação ────────────────────────────────────────────────────
      mudarCategoriaAnterior() {
        const keys = Object.keys(this.listAllConsumosLocal || {});
        if (!keys.length) return;
        const idx = keys.indexOf(this.categoriaAtual);
        this.categoriaAtual = keys[idx <= 0 ? keys.length - 1 : idx - 1];
        this.currentPageCategoria = 1;
      },
      mudarCategoriaSeguinte() {
        const keys = Object.keys(this.listAllConsumosLocal || {});
        if (!keys.length) return;
        const idx = keys.indexOf(this.categoriaAtual);
        this.categoriaAtual = keys[idx >= keys.length - 1 ? 0 : idx + 1];
        this.currentPageCategoria = 1;
      },
      goToPrevPageCategoria() {
        if (this.canGoPrevCategoria) this.currentPageCategoria--;
      },
      goToNextPageCategoria() {
        if (this.canGoNextCategoria) this.currentPageCategoria++;
      },
      goToPrevPageVisitas() {
        if (this.canGoPrevVisitas) this.currentPageVisitas--;
      },
      goToNextPageVisitas() {
        if (this.canGoNextVisitas) this.currentPageVisitas++;
      },

      abrirModalVisita(visita) {
        this.visitaSelecionada = visita;
        this.modalVisita = true;
      },
      verHistoricoCampanhas(cliente) {
        if (cliente.campanhas?.length) {
          this.modalCampanhas = true;
          this.campanhaSelecionadas = cliente.campanhas;
          return;
        }
        this.$notify({
          message: "<b>Nenhuma campanha enviada para este cliente.</b>",
          timeout: 2500,
          icon: "ni ni-bell-55",
          type: "warning",
        });
      },
      enviarMensagemindividual(cliente) {
        localStorage.setItem(
          "Abitue_enviarPara",
          JSON.stringify([cliente.qr_code]),
        );
        this.$router.push({
          path: "/campanhas/criar",
          query: { enviarIndividual: true },
        });
      },

      // ── Formatação ───────────────────────────────────────────────────
      formatarEuro(valor) {
        return new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(valor || 0);
      },
      formatarData(d) {
        if (!d) return "";
        return new Date(d).toLocaleDateString("pt-PT", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
      },
    },
  };
</script>

<style scoped>
  .cp-root {
    padding: 28px 28px 48px;
    font-family: "DM Sans", "Outfit", system-ui, sans-serif;
    min-height: 100vh;
    background: #f8f6f3;
  }

  /* ── HEADER ── */
  .cp-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 16px;
    flex-wrap: wrap;
  }
  .cp-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .cp-back-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    border: 1.5px solid #e8e4e0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5a534f;
    cursor: pointer;
    transition: all 0.12s;
    flex-shrink: 0;
  }
  .cp-back-btn:hover {
    border-color: #ff825d;
    color: #ff825d;
  }
  .cp-header-icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    background: #ff825d;
    border-radius: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    box-shadow: 0 4px 14px rgba(255, 130, 93, 0.3);
  }
  .cp-title {
    font-size: 20px;
    font-weight: 800;
    color: #1a1210;
    margin: 0;
    letter-spacing: -0.4px;
  }
  .cp-sub {
    font-size: 13px;
    color: #b0a8a0;
    margin: 2px 0 0;
  }
  .cp-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .cp-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 9px 16px;
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 11px;
    font-size: 13.5px;
    font-weight: 500;
    color: #5a534f;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
    white-space: nowrap;
  }
  .cp-action-btn:hover {
    border-color: #ff825d;
    color: #ff825d;
    background: #fff8f5;
  }

  /* ── MODAIS ── */
  .cp-modal-scroll {
    max-height: 60vh;
    overflow-y: auto;
  }
  .cp-modal-empty {
    text-align: center;
    padding: 40px;
    color: #b0a8a0;
    font-style: italic;
  }

  .cp-campanha-item {
    padding: 14px 0;
    border-bottom: 1px solid #f5f2ef;
  }
  .cp-campanha-item:last-child {
    border-bottom: none;
  }
  .cp-campanha-meta {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 4px;
  }
  .cp-campanha-titulo {
    font-size: 14px;
    font-weight: 700;
    color: #1a1210;
  }
  .cp-campanha-canal {
    font-size: 11px;
    background: #f0ece8;
    color: #6b6460;
    border-radius: 20px;
    padding: 2px 8px;
  }
  .cp-campanha-msg {
    font-size: 13px;
    color: #5a534f;
    margin: 0 0 4px;
    line-height: 1.5;
  }
  .cp-campanha-data {
    font-size: 11.5px;
    color: #b0a8a0;
  }

  .cp-visita-meta {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    background: #f8f6f3;
    border-radius: 12px;
    padding: 14px 18px;
    margin-bottom: 16px;
  }
  .cp-visita-meta-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 100px;
  }
  .cp-visita-meta-item span {
    font-size: 11px;
    font-weight: 700;
    color: #b0a8a0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  .cp-visita-meta-item strong {
    font-size: 14px;
    font-weight: 600;
    color: #1a1210;
  }
  .cp-visita-total {
    color: #ff825d !important;
  }

  .cp-consumos-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .cp-consumo-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #faf8f6;
  }
  .cp-consumo-row:last-child {
    border-bottom: none;
  }
  .cp-consumo-nome {
    font-size: 13.5px;
    font-weight: 600;
    color: #1a1210;
    display: block;
  }
  .cp-consumo-cat {
    font-size: 11.5px;
    color: #b0a8a0;
  }
  .cp-consumo-qty {
    font-size: 13px;
    color: #6b6460;
  }
  .cp-consumo-val {
    font-size: 13.5px;
    font-weight: 700;
    color: #1a1210;
  }

  @media (max-width: 768px) {
    .cp-root {
      padding: 16px 14px 40px;
    }
    .cp-header {
      flex-direction: column;
      align-items: flex-start;
    }
    .cp-header-right {
      width: 100%;
    }
    .cp-action-btn {
      flex: 1;
      justify-content: center;
    }
  }
</style>
